import { cn } from '@/lib/utils';
import { FacesheetOutlineItems } from './FacesheetOutlineItems';
import type { FacesheetOutlineItem } from './types';

interface FacesheetOutlineSidebarProps {
  items: FacesheetOutlineItem[];
  activeAnchorId?: string;
  onSelectItem: (anchorId: string) => void;
  className?: string;
}

export const FacesheetOutlineSidebar = ({
  items,
  activeAnchorId,
  onSelectItem,
  className,
}: FacesheetOutlineSidebarProps) => {
  return (
    <aside
      className={cn(
        'flex h-full w-full flex-col gap-3 px-5 pt-5 pb-4',
        className,
      )}
      aria-label="Facesheet Outline"
    >
      <h2 className="text-lg leading-none font-bold text-gray-900">
        Facesheet Outline
      </h2>

      <nav className="flex flex-col gap-1" aria-label="Facesheet sections">
        <FacesheetOutlineItems
          items={items}
          activeAnchorId={activeAnchorId}
          onSelectItem={onSelectItem}
        />
      </nav>
    </aside>
  );
};
